export const getTopLocationCardFluentV2Style = palette => ({
  '.top-locations-card': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  '.top-locations-card .metric-picker-container': {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
  },
  '.top-locations-card .metric-picker-container .metric-picker': {
    padding: '0',
    border: '0',
    fontWeight: '400',
    margin: '0',
    fontSize: 12,
    lineHeight: 'normal',
  },
  '.top-locations-card .metric-picker.open .dropdown-menu': {
    zIndex: 110,
  },
  '.top-locations-card .location-data': {
    flex: '1',
    flexBasis: 1,
    minHeight: 1,
    display: 'flex',
    position: 'relative',
  },
  '.top-locations-card .location-data .location-map': {
    display: 'flex',
    flex: '6',
  },
  '.top-locations-card .location-data .location-map>div': {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper': {
    flex: '1',
    display: 'flex',
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container': {
    flex: '1',
    position: 'relative',
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container .MicrosoftMap': {
    position: 'absolute !important',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 'inherit !important',
    height: 'inherit !important',
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container .tool-tip-container': {
    padding: 15,
    boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    '@supports (backdrop-filter: blur(60px))': {
      backdropFilter: 'blur(60px)',
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container .tool-tip-container .date-range': {
    whiteSpace: 'nowrap',
    margin: '10px 0',
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container .tool-tip-container .metric-container': {
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container .tool-tip-container .metric-container .metric-name': {
    marginRight: 5,
  },
  '.top-locations-card .location-data .location-map>div .map-container-wrapper .map-container .tool-tip-container .metric-container .metric-value': {
    fontWeight: 'bold',
  },
  '.top-locations-card .location-data .location-map>div .zoom-to-all': {
    display: 'none',
  },
  '.top-locations-card .location-data .data-container': {
    display: 'flex',
    flexDirection: 'column',
    flex: '4',
  },
  '.top-locations-card .location-data .data-container .grid-row-hover': {
    backgroundColor: `${palette.neutralLighter} !important`,
  },
  '.top-locations-card .location-data .data-container .data-grid-row-10': {
    '-ms-grid-row': '10',
    gridRow: '10',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-9': {
    '-ms-grid-row': '9',
    gridRow: '9',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-8': {
    '-ms-grid-row': '8',
    gridRow: '8',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-7': {
    '-ms-grid-row': '7',
    gridRow: '7',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-6': {
    '-ms-grid-row': '6',
    gridRow: '6',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-5': {
    '-ms-grid-row': '5',
    gridRow: '5',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-4': {
    '-ms-grid-row': '4',
    gridRow: '4',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-3': {
    '-ms-grid-row': '3',
    gridRow: '3',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-2': {
    '-ms-grid-row': '2',
    gridRow: '2',
    display: 'flex',
    alignItems: 'center',
  },
  '.top-locations-card .location-data .data-container .data-grid-row-1': {
    '-ms-grid-row': '1',
    gridRow: '1',
    display: 'flex',
    alignItems: 'center',
    borderTop: `1px solid ${palette.neutralLighter}`,
  },
  '.top-locations-card .location-data .data-container .scroll-container': {
    overflowY: 'auto',
    flex: '1',
  },
  '.top-locations-card .location-data .data-container .scroll-container .data-grid': {
    display: 'grid',
    fallbacks: [
      {
        display: '-ms-grid',
      },
    ],
    alignSelf: 'flex-start',
    overflowY: 'auto',
    '-ms-grid-template-columns': '1fr auto',
    gridTemplateColumns: '1fr auto',
  },
  '.top-locations-card .location-data .data-container .scroll-container .data-grid .location-name': {
    padding: '0 10px',
    height: 42,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-ms-grid-column': '1',
    gridColumn: '1',
    marginLeft: 10,
    borderBottom: `1px solid ${palette.neutralLighter}`,
  },
  '.top-locations-card .location-data .data-container .scroll-container .data-grid .kpi': {
    justifyContent: 'flex-end',
    paddingRight: 10,
    '-ms-grid-column': '2',
    gridColumn: '2',
    borderBottom: `1px solid ${palette.neutralLighter}`,
  },
  '.top-locations-card .location-data .data-container .recommendation-container': {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0 10px 10px',
  },
  '.top-locations-card .location-data .data-container .recommendation-container .recommendation-icon-container': {
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 5,
    border: '1px solid #1570A6',
    backgroundColor: '#e5f5fb',
    width: 30,
    height: 30,
  },
  '.top-locations-card .location-data .data-container .recommendation-container .recommendation-icon-container .recommendation-light-bulb': {
    color: '#1570A6 !important',
  },
  '.top-locations-card .location-data .data-container .recommendation-container .recommendation-icon-container .recommendation-light-bulb:before': {
    fontSize: '16px !important',
  },
  '.top-locations-card .location-data .data-container .recommendation-container .msg': {
    display: 'inline',
    color: '#006464',
  },
  '.top-locations-card .location-data .data-container .recommendation-container .view-recommendations, .top-locations-card .location-data .data-container .recommendation-container .dismiss-recommendations': {
    color: '#1570A6',
  },
  '.top-locations-card .location-data .data-container:hover .scroll-bar-cover': {
    display: 'none',
  },
  '.top-locations-card .location-data .data-container .scroll-bar-cover': {
    position: 'absolute',
    background: 'white',
    right: '0',
    top: '0',
    overflow: 'hidden',
  },
  '.top-locations-card .location-data .data-container .scroll-bar-cover .block-container': {
    position: 'absolute',
    width: '100%',
  },
  '.top-locations-card .location-data .data-container .scroll-bar-cover .block-container .cover-block': {
    height: 42,
  },
  '.top-locations-card .location-links': {
    alignItems: 'baseline',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    marginTop: 10,
  },
  '.top-locations-card .location-links .view-picker-clickLink': {
    display: 'none',
  },
  '.top-locations-card .bubble-icon': {
    width: 12,
    height: 12,
    border: '1px solid #107C10',
    borderRadius: 6,
    marginRight: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '.top-locations-card .bubble-icon .dot': {
    width: 2,
    height: 2,
    border: '2px solid #107C10',
    borderRadius: 2,
  },
  '.overview-card .small_layout .location-map': {
    display: 'none',
  },
  '.overview-card .small_layout.top-locations-card .location-data .data-container .scroll-container .data-grid .location-name': {
    marginLeft: 0,
  },
  '.overview-card .small_layout .data-container': {
    display: 'none',
    flex: '1',
  },
  '.overview-card .small_layout .location-links .view-picker-clickLink': {
    display: 'block',
    cursor: 'pointer',
  },
});
